import React, { useState, useEffect, useRef, useInterval } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { fetchDefault } from '../Utils.js';
import { useHistory } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import MessageIcon from '@material-ui/icons/Message';
import FormatBoldIcon from '@material-ui/icons/FormatBold';


const useStyles = makeStyles(theme => ({
    contents: {
        marginBottom: 5
    },
    button: {
        marginTop: 15,
        marginRight: 15,
        fontSize: 15,
    },
    catManualImage: {
        position: "relative"
    },
    catManualText1: {
        position: "absolute",
        top: 215,
        left: 105,
    },
    catManualText2: {
        position: "absolute",
        top: 215,
        left: 146,
    },
}));


const installmentList = [
    {
        value: 2,
        label: '2개월',
    },
    {
        value: 3,
        label: '3개월',
    },
    {
        value: 4,
        label: '4개월',
    },
    {
        value: 5,
        label: '5개월',
    },
    {
        value: 6,
        label: '6개월',
    },
    {
        value: 7,
        label: '7개월',
    },
    {
        value: 8,
        label: '8개월',
    },
    {
        value: 9,
        label: '9개월',
    },
    {
        value: 10,
        label: '10개월',
    },
    {
        value: 11,
        label: '11개월',
    },
    {
        value: 12,
        label: '12개월',
    },
];

export default function HowPayDialog(props) {
    const classes = useStyles();
    let history = useHistory();

    const [open, setOpen] = React.useState(false);
    const [completeOpen, setCompleteOpen] = React.useState(false);
    const [payText, setPayText] = React.useState('');
    const [pin1, setPin1] = React.useState('');
    const [pin2, setPin2] = React.useState('');

    const [errorOpen, setErrorOpen] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState();

    const savedPayment = useRef();
    const savedInstallment = useRef();
    const closeCompleteDialog = useRef();

    const [installmentOpen, setInstallmentOpen] = React.useState(false);
    const [installmentMonth, setInstallmentMonth] = React.useState(3);
    const handleInstallmentMonth = event => {
        setInstallmentMonth(event.target.value);
    };

    const [wireOpen, setWireOpen] = React.useState(false);
    const [depositorDialogOpen, setDepositorDialogOpen] = React.useState(false);
    const [depositor, setDepositor] = React.useState('');
    const [transferCheckingOpen, setTransferCheckingOpen] = React.useState(false);
    const handleDepositor = event => {
        setDepositor(event.target.value);
    };


    //결제하기
    const handleClickOpen = (payment) => {

        savedPayment.current = payment;
        savedInstallment.current = 0;

        fetchDefault(props.controllerUrl + '&payment=' + payment,
            (data) => {
                if (payment == -1) {
                    setCompleteOpen(true);
                    closeCompleteDialog.current = setTimeout(moveToHome, 5000);
                    return;
                } else {
                    setOpen(true);
                    startCloseDialogTimer();
                }

                //setPinId(data.pinId);
                pinId.current = data.pinId;
                setPin1(data.pin1);
                setPin2(data.pin2);

                if (payment == 0) {
                    setPayText('카드로 결제하기');
                } else if (payment == 1) {
                    setPayText('현금으로 결제하기');
                }
            },
            //(error) => {
            //    setErrorOpen(true);
            //    setErrorMsg(error.error);
            //}
        );
    };

    const refreshPin = () => {
        fetchDefault(props.controllerUrl + '&payment=' + savedPayment.current + '&installment=' + savedInstallment.current,
            (data) => {
                //setPinId(data.pinId);
                pinId.current = data.pinId;
                setPin1(data.pin1);
                setPin2(data.pin2);
            }
        );
    }

    //할부결제하기
    const handleInstallmentPayOpen = () => {
        savedPayment.current = 0;
        savedInstallment.current = installmentMonth;
        fetchDefault(props.controllerUrl + '&payment=0&installment=' + installmentMonth,
            (data) => {
                setOpen(true);
                startCloseDialogTimer();

                pinId.current = data.pinId;
                setPin1(data.pin1);
                setPin2(data.pin2);

                setPayText(installmentMonth + '개월 할부로 결제하기');
            },
            //(error) => {
            //    setErrorOpen(true);
            //    setErrorMsg(error.error);
            //}
        );
    };

    const handleClose = () => {
        setOpen(false);
    };

    //Dialog 타임아웃(10분)
    let popupTimeout = null;
    const startCloseDialogTimer = () => {
        popupTimeout = setTimeout(handleClose, 600000);
    };

    const pinId = useRef();
    const depositorRef = useRef();
    const payPriceRef = useRef();
    const controllerUrlRef = useRef();
    const overlapRef = useRef();
    const loginIdRef = useRef();
    const passwordRef = useRef();
    const priceRef = useRef();
    

    useEffect(() => {
        loginIdRef.current = '';
        passwordRef.current = '';
        priceRef.current = 0;

        const checkPos = setInterval(() => {
            if (pinId.current) {
                fetchDefault('/Payment/CheckPos?pinId=' + pinId.current,
                    (data) => {
                        if (data.success) {
                            //clearInterval(checkPos);
                            setOpen(false);
                            setCompleteOpen(true);
                            closeCompleteDialog.current = setTimeout(moveToHome, 10000);
                        }
                    },
                    (error) => {
                        //clearInterval(checkPos);

                        setErrorOpen(true);
                        setErrorMsg(error.error);

                        //alert(error.error);
                        moveToHome();
                    }
                );
            }

            if (depositorRef.current) {
                CompleteBankTransfer(true);
            }

        }, 2000);

        return () => {
            clearTimeout(closeCompleteDialog.current);
            clearTimeout(popupTimeout);
            clearInterval(checkPos);
            
        }
    }, []);


    const moveToHome = () => {
        setCompleteOpen(false);
        if (props.homeUrl) {
            window.location.assign(props.homeUrl);
        } else {
            history.push('/');
        }
    };

    const CompleteBankTransfer = (isInterval) => {

        if (overlapRef.current == true) {
            return;
        }
        overlapRef.current = true;


        fetchDefault('Payment/CompleteBankTransfer?name=' + depositorRef.current + '&loginId=' + loginIdRef.current + '&password=' + passwordRef.current + '&price=' + priceRef.current + '&encodedOrder=' + encodeURIComponent(controllerUrlRef.current + '&payment=-1'),
            (data) => {
                overlapRef.current = false

                if ((controllerUrlRef.current.includes('/Payment/ChargeMoney') && data.isSuccess == true)) {
                    //충전일 때
                    //결제 진행
                    homepageTransferOpen();

                } else if (data.point != null && data.point >= payPriceRef.current && !controllerUrlRef.current.includes('/Payment/ChargeMoney')) {
                    
                    //결제 진행
                    homepageTransferOpen();
                }
                else {

                    if (data.isSuccess == true) {
                        alert("입금된 금액이 부족합니다. 입금하신 금액을 확인해 주세요.")
                    }

                    if (isInterval != true) {
                        setTransferCheckingOpen(true);
                    }
                }
            },
            (error) => {
                overlapRef.current = false
            }
        );
    };

    const startTransferCheckingTimer = () => {
        popupTimeout = setTimeout(handleClose, 600000);
    };

    //홈페이지 계좌이체 결제하기
    const homepageTransferOpen = () => {

        depositorRef.current = null;

        //입금대기 목록 완료로 업데이트

        fetchDefault(controllerUrlRef.current + '&payment=-1',
            (data) => {

                fetchDefault('Payment/CompleteBankTransferOrder?name=' + depositorRef.current + '&loginId=' + loginIdRef.current + '&password=' + passwordRef.current + '&price=' + priceRef.current + '&encodedOrder=' + encodeURIComponent(controllerUrlRef.current + '&payment=-1'),
                    (data) => {
                    },
                    (error) => {
                    }
                );


                setCompleteOpen(true);
                closeCompleteDialog.current = setTimeout(moveToHome, 5000);
            },
            //(error) => {
            //    setErrorOpen(true);
            //    setErrorMsg(error.error);
            //}
        );
    };

    function onClickPayment() {

        controllerUrlRef.current = props.controllerUrl;
        payPriceRef.current = props.totalPrice + props.usePoint;
        priceRef.current = props.totalPrice;

        if (props.isSnack) {
            //자판기일 경우 아이디 비번 먼저 확인
            fetchDefault('Payment/CheckIdAndPassword?loginId=' + props.loginId + '&password=' + props.password,
                (data) => {
                    if (data.isCorrect) {

                        loginIdRef.current = props.loginId;
                        passwordRef.current = props.password;

                        setWireOpen(true);
                    }
                }
            );
        } else {
            //setWireOpen(true);
            fetchDefault(props.controllerUrl, (data) => {
                setWireOpen(true);
            });
        }

        
        //fetchDefault('User/GetMemberInfo',
        //    (m) => {

        //        /* 1. 가맹점 식별하기 */
        //        const { IMP } = window;
        //        IMP.init('imp18196809');

        //        const merchantUid = `mid_${new Date().getTime()}`;
        //        /* 2. 결제 데이터 정의하기 */
        //        const data = {
        //            pg: 'html5_inicis',                           // PG사
        //            pay_method: 'card',                           // 결제수단
        //            merchant_uid: merchantUid,   // 주문번호
        //            amount: props.totalPrice,                      // 결제금액
        //            name: document.title + ' 이용권',               // 주문명
        //            buyer_name: m.loginId,                           // 구매자 이름
        //            buyer_tel: m.phone,                     // 구매자 전화번호
        //            buyer_email: '',               // 구매자 이메일
        //            buyer_addr: '',                    // 구매자 주소
        //            buyer_postcode: '',                      // 구매자 우편번호
        //            m_redirect_url: 'http://' + window.location.hostname + '/paymentComplete?totalPrice=' + props.totalPrice + '&url=' + encodeURIComponent(props.controllerUrl)
        //        };

        //        /* 4. 결제 창 호출하기 */
        //        IMP.request_pay(data, callback);

        //    }
        //);
    
    }

    /* 3. 콜백 함수 정의하기 */
    function callback(response) {
        const {
            success,
            merchant_uid,
            error_msg,
        } = response;

        if (success) {

            fetchDefault('Payment/ChargePointFromWeb?merchantUid=' + merchant_uid  + '&point=' + props.totalPrice,
                (data) => {
                   
                    fetchDefault(props.controllerUrl + '&payment=0',
                        (data) => {
                            setCompleteOpen(true);
                            closeCompleteDialog.current = setTimeout(moveToHome, 5000);
                        }
                    );

                }
            );

        } else {
            alert(`결제 실패: ${error_msg}`);
        }
    }

    return (
        <div>
            {props.totalPrice > 0 ?
                (
                    <div>
                        {'192.168.0.2' == '192.168.0.2' ?
                            (
                                <div>
                                    <Button variant="outlined" color="primary" onClick={() => handleClickOpen(0)} className={classes.button}>
                                        카드로 결제하기
                                    </Button>
                                    <Button variant="outlined" color="primary" onClick={() => handleClickOpen(1)} className={classes.button}>
                                        현금으로 결제하기
                                    </Button>
                                    <Button variant="outlined" color="primary" onClick={onClickPayment} className={classes.button}>
                                        계좌이체로 결제하기
                                    </Button>
                                    {props.totalPrice > 50000 ? (<Button color="primary" onClick={() => setInstallmentOpen(true)} className={classes.button} style={{ fontSize: 12 }}>카드할부</Button>) : (<div></div>)}
                                </div>
                            ) : (
                                <div>
                                    <Button variant="outlined" color="primary" onClick={onClickPayment} className={classes.button}>
                                        결제하기
                                    </Button>
                                </div>
                            )
                        }
                    </div>
                ) : (
                    <Button variant="outlined" color="primary" onClick={() => handleClickOpen(-1)} className={classes.button}>
                        결제하기
                    </Button>
                )
            }

            <div style={{ marginBottom: 20 }}>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">{payText}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    <Typography variant="body1" color="textPrimary" className={classes.contents}>
                                1. 카페 입구 근처에 있는 계산대로 이동해주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.contents}>
                                2. 계산대에 인증번호 "{pin1}{pin2}"를 입력해주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.contents}>
                                3. 계산대 안내에 따라 결제를 진행해주세요.
                    </Typography>
                    <div className={classes.catManualImage}>
                        <img alt="loading..." src={require('../../images/cat_manual_number.png')} style={{ width: 240 }} />
                        <h2 className={classes.catManualText1}>
                            {pin1}
                        </h2>
                        <h2 className={classes.catManualText2}>
                            {pin2}
                        </h2>
                    </div>
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={refreshPin} color="primary">
                        인증번호 새로고침
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        취소하기
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={completeOpen}
                onClose={moveToHome}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        결제가 완료되었습니다! {props.isSnack ? ('원하시는 상품을 수령해주세요.') : ('')}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={moveToHome}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={errorOpen}
                onClose={() => setErrorOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        {errorMsg}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setErrorOpen(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={installmentOpen}
                onClose={() => setInstallmentOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        할부개월을 선택해주세요.
                    </Typography>

                    <TextField
                        id="outlined-select-currency"
                        select
                        label="할부개월"
                        className={classes.textField}
                        value={installmentMonth}
                        onChange={handleInstallmentMonth}
                        margin="normal"
                        variant="outlined"
                    >
                        {installmentList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { setInstallmentOpen(false); handleInstallmentPayOpen(); }}>
                        <Typography variant="h6">
                            결제하기
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={() => setInstallmentOpen(false)}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            {/*  
            <Dialog
                open={wireOpen}
                onClose={() => setWireOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        잔액이 부족합니다. 먼저 잔액 충전 후 이용해주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        아래 계좌로 충전을 원하시는 금액 입금 후 입금완료를 눌러주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        문자로 입금자명을 보내시면 1시간 이내로 충전됩니다.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        충전금액 확인 후 다시 결제를 진행해주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        (입금자명을 아이디로 설정 시 문자전송 불필요)
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 20 }}>
                        <FormatBoldIcon />
                        카카오뱅크
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 0 }}>
                        3333-04-4374752 홍정우
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        <MessageIcon /> 010-3849-0843
                    </Typography>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        (10,000원 이상 충전 시 5% 추가 충전)
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setWireOpen(false)}>
                        <Typography variant="h6">
                            입금완료
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={CompleteBankTransfer}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
            */}  

            <Dialog
                open={wireOpen}
                onClose={() => setWireOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        아래 계좌로 충전을 원하시는 금액 계좌이체 후 [입금완료]를 눌러주세요.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 10 }}>
                        ({props.totalPrice} 원 부족 ※ 부족한 금액보다 더 입금하시면 아이디에 저장되어 다음에 이용가능. 10,000원 이상 충전 시 5% 추가 충전)
                    </Typography>
                    
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 20 }}>
                        <FormatBoldIcon />
                        하나은행
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 0 }}>
                        01038490843 홍정우
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                            setDepositorDialogOpen(true);
                            depositorRef.current = "temp_";
                        }
                    }>
                        <Typography variant="h6">
                            입금완료
                        </Typography>
                    </Button>    
                    <Button color="primary" onClick={() => setWireOpen(false)}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={depositorDialogOpen}
                onClose={() => {
                    setDepositorDialogOpen(false);
                    depositorRef.current = depositor;
                }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        계좌이체하신 입금자명을 입력해 주세요. (계좌이체 입금자명과 여기에 입력하신 이름이 같아야 결제되십니다.)
                    </Typography>

                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 5 }}>
                        ※ 잘못 입력하셨으면 [닫기] 누르신 후 다시 입금자명 입력해 주시면 되십니다.
                    </Typography>

                    <TextField
                        id="outlined-select-currency"
                        label="입금자명"
                        className={classes.textField}
                        value={depositor}
                        onChange={handleDepositor}
                        margin="normal"
                        variant="outlined"
                    >
                    </TextField>

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        if (depositor.length > 0) {
                            depositorRef.current = depositor; setDepositorDialogOpen(false); CompleteBankTransfer(false);
                        } else {
                            alert('입금자명을 입력해주세요.');
                        }
                        
                    }}>
                        <Typography variant="h6">
                            입력
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={() => {
                            setDepositorDialogOpen(false);
                            depositorRef.current = depositor;
                        }
                    }>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={transferCheckingOpen}
                onClose={() => setTransferCheckingOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 20 }}>
                        결제 확인 중입니다. 잠시만 기다려주세요..
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 20 }}>
                        확인 완료 시 자동으로 다음 화면으로 넘어갑니다.
                    </Typography>
                    <Typography variant="body1" color="textPrimary" style={{ marginTop: 20 }}>
                        (5분 이상 결제가 진행되지 않으시면, 010-3849-0843 에 문자로 입금자명을 남겨주세요.)
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setTransferCheckingOpen(false)}>
                        <Typography variant="h6">
                            닫기
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}




// WEBPACK FOOTER //
// ./src/components/seat/HowPayDialog.js